import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useQuiz, useQuizTimer } from '../../pages/quiz/hooks'
import { convertSeconds, getScoreForAnswer, gradeAssessment } from '../../utils'
import { makeStyles } from 'tss-react/mui';
import resultImage from '../..//assets/images/quiz/result-header.jpeg';
import backIcon from '../../assets/images/quiz/back.svg';
import { useDiagnosticTest } from '../../pages/diagnosticTestV2/hooks';
import { getAttemptHistoryApi } from '../../store/scoring/scoringBaseApi';

const useStyles = makeStyles()((theme) => ({
    highlightedText: {
        // color: 'green',
        fontWeight: 600
    },
    resultsOverview: {
        textAlign: 'center',
        marginBottom: '70px',
        position: 'relative',
        padding: '24px 0px',
        position: 'sticky',
        top: 0,
        left: 0,
        zIndex: 3
    },
    resultsOverviewParagraph: {
        marginTop: '0px',
        fontWeight: 300,
        fontSize: '18px',
        marginBottom: '0px',
        lineHeight: 2
    },
    bgImage: {
        position: 'absolute',
        top: '-2px',
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        // opacity: 0.87,
        background: `url(${resultImage}) center center / cover no-repeat`,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',  // semi-transparent white
        backgroundBlendMode: 'lighten',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: 'drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.1))'
    },
    actionBtnContainer: {
        position: 'absolute',
        top: '24px',
        left: '20px',
        zIndex: 4
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        transition: 'transform 0.1s ease, box-shadow 0.1s ease',
        width: '70px',
        height: '70px',
        '&:disabled': {
            opacity: 0.5,
            cursor: 'not-allowed',
        },
        '&:not(:disabled):active': {
            transform: 'scale(0.95)',
        },
    },
    buttonImage: {
        width: '100%'
    }
}));

export default function OverView({ onNavigateBack }) {
    const { quizDetails, result, setGradingResult, type, courseAssigned, speechEvaluationScore, setOverallPercentage, overallPercentage, evaluationResult } = useQuiz();
    // const { endTime, endedAt } = useQuizTimer();
    const [percentage, setPercentage] = useState();
    const { readingScore } = useDiagnosticTest();
    // const gradingStatus = useRef({ grade: null, passed: null });
    // const totalQuestionAttempted = result.length;
    // const profile = useRef(JSON.parse(localStorage.getItem('profile')));
    const { classes } = useStyles();

    const obtainedScore = useMemo(() => parseFloat(evaluationResult.marksSecured).toFixed(2), [evaluationResult])

    // gradingStatus.current = gradeAssessment(quizDetails.gradingModel, obtainedScore, quizDetails.passGrade);

    // const calculateStatus = gradingStatus.current.passed ? 'Passed' : 'Failed';
    // const statusColor = gradingStatus.current.passed ? 'var(--color-green)' : 'var(--color-danger)';

    // "Best so far" — only meaningful when this isn't the student's first attempt.
    const [bestSoFar, setBestSoFar] = useState(null); // { bestPercentage, attemptCount, bestAttemptNumber }

    useEffect(() => {
        let percentage = Math.round((obtainedScore / evaluationResult.totalMarks) * 100);
        setPercentage(percentage);

        // Pull attempt history for this (student, assessment) — works in the background.
        // Defensive: any failure leaves bestSoFar null and the line stays hidden.
        try {
            const profile = JSON.parse(localStorage.getItem('profile') || '{}');
            const studentId = profile?.id;
            // quizDetails.id is the assessment id; fallback to chapterId if it isn't carried.
            const assessmentId = quizDetails?.id || quizDetails?.assessmentId || quizDetails?.chapterId;
            if (studentId && assessmentId) {
                getAttemptHistoryApi(studentId, assessmentId)
                    .then((resp) => {
                        const d = resp?.data;
                        if (!d || !d.attempts?.length || d.attemptCount < 2) return;
                        const best = d.attempts.find((a) => a.best) || null;
                        setBestSoFar({
                            bestPercentage: d.bestPercentage,
                            attemptCount: d.attemptCount,
                            bestAttemptNumber: best ? best.attemptNumber : null,
                        });
                    })
                    .catch(() => { /* silent */ });
            }
        } catch (_e) { /* silent */ }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const ordinal = (n) => {
        const s = ['th', 'st', 'nd', 'rd'];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    return (
        <div className={classes.resultsOverview}>
            <div className={classes.bgImage}></div>
            <div className={classes.actionBtnContainer}>
                <button className={classes.actionButton} onClick={onNavigateBack}>
                    <img className={classes.buttonImage} src={backIcon} />
                </button>
            </div>
            <div style={{ position: 'relative' }}>
                {/* <p className={classes.resultsOverviewParagraph}>
                    Name:{' '}
                    <span style={{fontWeight: 600}}>{profile.current.userName}</span>
                </p>
                <p className={classes.resultsOverviewParagraph}>
                    Grade: <span style={{ fontWeight: 600 }}> {profile.current?.gradeLevel} </span>
                </p> */}
                {/* <p className={classes.resultsOverviewParagraph}>
                    You attempted questions:{' '}
                    <span style={classes.highlightedText}> {totalQuestionAttempted} </span>/{' '}
                    {quizDetails.noOfQuestions}
                </p> */}
                <p className={classes.resultsOverviewParagraph}>
                    Marks secured: <span className={classes.highlightedText}> {Math.round(obtainedScore)} /{' '}{evaluationResult.totalMarks}</span>
                </p>
                <p className={classes.resultsOverviewParagraph}>
                    {type === 'diagnostic-test'
                        && courseAssigned && Object.keys(courseAssigned).length > 0 ?
                        <>Course Assigned: <span className={classes.highlightedText}> ${courseAssigned.courseName}</span></> : <>Comprehension percentage: <span className={classes.highlightedText}>{percentage}%</span></>}
                </p>
                {bestSoFar && (
                    <p className={classes.resultsOverviewParagraph}>
                        Best so far: <span className={classes.highlightedText}>
                            {Number(bestSoFar.bestPercentage).toFixed(1)}%
                        </span>
                        {bestSoFar.bestAttemptNumber
                            ? ` (your ${ordinal(bestSoFar.bestAttemptNumber)} attempt)`
                            : ''}
                        {' · '}{bestSoFar.attemptCount} total attempts
                    </p>
                )}
                {type === 'diagnostic-test-v2' && (
                    <>
                        <p className={classes.resultsOverviewParagraph}>
                            Reading (speech evaluation): <span className={classes.highlightedText}> {Math.round(readingScore) || 0}% </span>
                        </p>
                        <p className={classes.resultsOverviewParagraph}>
                            Reading + Comprehension Average: <span className={classes.highlightedText}> {overallPercentage}% </span>
                        </p>
                    </>
                )}
            </div>
            {/* <p className={classes.resultsOverviewParagraph}>
                Time Spent:<span className={classes.highlightedText}> {convertSeconds(endTime)} </span>
            </p> */}
            {/* <p className={classes.resultsOverviewParagraph}>
                Status:<span style={{ color: statusColor }}> {calculateStatus}</span>
            </p> */}
        </div>
    )
}